import { isEmpty } from 'lodash';
import electionApi from '~/clientApis/electionApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { getStore } from '~/mobx/AppStore';

const assignUnassignedAttributes = async (electionId: string) => {
    const { adminStore } = getStore();
    const unassigned = adminStore.attributesState.filter((attr) => !attr.isAttributeAssigned);

    if (isEmpty(unassigned)) {
        return;
    }

    // Assign unassigned attributes
    const definitionIds = unassigned.map((attr) => attr.id);
    await electionApi.assignAttributesToElection(electionId, { definitionIds });

    // If assign succeeded, mark them as assigned locally
    adminStore.setAttributesState(
        adminStore.attributesState.map((attr) =>
            definitionIds.includes(attr.id) ? { ...attr, isAttributeAssigned: true } : attr
        )
    );
};

const buildAttributesPayload = () => {
    const { adminStore } = getStore();

    return adminStore.attributesState.map((attribute) => {
        const { id: definitionId, type = '', value = '' } = attribute;

        const payload = type === 'single_select' ? { selectIds: value ? [value] : [] } : { value: value };

        return {
            definitionId,
            type,
            payload,
        };
    });
};

const updateElection = async () => {
    const { adminStore } = getStore();
    const electionId = adminStore.election?.id || '';

    // Validate form and show errors only on updateElection
    const showValidationErrors = adminStore.validateForm();
    // Early return if no valid election ID
    if (!electionId || showValidationErrors) {
        return;
    }

    adminStore.setIsUpdatingElection(true);

    try {
        // Assign any attributes that haven't yet been associated with the election
        await assignUnassignedAttributes(electionId);

        // Prepare and call updated election attributes
        const attributes = buildAttributesPayload();
        await electionApi.updateElectionAttributes(electionId, { attributes });
    } catch (error) {
        showMessageModal('error', 'Error updating election data');
    } finally {
        adminStore.setIsUpdatingElection(false);
    }
};

export default updateElection;
